import addAuthHeader from '~/contexts/Auth/util/addAuthHeader';

const PATH = '/analytics/uuid.json';

export default (token: string | null) => {
  const url = new URL(`${process.env.MONOLITH_HOST_URL}${PATH}`, window.location.origin);

  url.searchParams.append('referrer', encodeURIComponent(document.referrer));

  let headers: Record<string, string> = {
    Accept: 'application/json',
  };

  if (token) {
    headers = addAuthHeader(headers, token);
  }

  return fetch(url.toString(), {
    credentials: process.env.NODE_ENV === 'development' ? 'include' : 'same-origin',
    headers,
  });
};
